import IconBox from '@/components/iconBox';
import ICONS from '@/shared/entities/constants/icons';
import React, { useEffect, useRef } from 'react';
import { Button, Dialog, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface DialogSaveChangesBeforeLeaveThePageProps {
  open: boolean;
  confirm: (confirmation: boolean | null) => void;
}

export const DialogSaveChangesBeforeLeaveThePage: React.FC<
  DialogSaveChangesBeforeLeaveThePageProps
> = ({ open, confirm }) => {
  const useRefDialog = useRef({ open: () => {}, dismiss: () => {} });

  useEffect(() => {
    open ? useRefDialog.current.open() : useRefDialog.current.dismiss();
  }, [open]);

  return (
    <Dialog
      shadow
      outlined
      rounded
      instanceEmitter={useRefDialog.current}
      onClose={() => confirm(null)}
      elevation={2}
      size='larger'
      body={
        <Grid column padding={30}>
          <Grid margin='0 0 32px' alignContent='center' stretch>
            <IconBox icon={ICONS.ALERT} size={70} circle color='danger' />
          </Grid>

          <Grid margin='0 0 16px' alignContent='center' stretch>
            <Text
              value='Você fez alterações que ainda não foram salvas'
              title
              size='medium'
              color='colorDefault'
            />
          </Grid>

          <Grid margin='0 0 24px' alignContent='center' stretch>
            <Text value='Deseja salvar antes de sair?' size='medium' textAlign='center' />
          </Grid>

          <div style={{ width: 458, margin: 'auto' }}>
            <Grid gap={16}>
              <Button
                size='larger'
                testId='confirm_no'
                onClick={() => confirm(false)}
                label='Descartar alterações'
                solo
                outlined
                full
              />

              <Button
                size='larger'
                testId='confirm_yes'
                onClick={() => confirm(true)}
                label='Salvar agora'
                outlined
                full
              />
            </Grid>
          </div>
        </Grid>
      }
    />
  );
};
